class FooterNewsletter extends window.BAO.CustomElement() {
  static get requiredElements () {
    return [
      'trigger',
      'panel',
      'form',
      'list',
      'fields',
      'email',
      'consent',
      'success',
    ]
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.trigger.element,
      'click',
      this.onTriggerClick.bind(this),
    )

    this.listeners.add(
      this.els.form.element,
      'submit',
      this.onFormSubmit.bind(this),
    )
  }

  onTriggerClick () {
    this.els.trigger.element.setAttribute('aria-hidden', true)
    this.els.panel.element.setAttribute('aria-hidden', false)
  }

  onFormSubmit (e) {
    e.preventDefault()

    const listId = this?.els?.list?.element?.value
    const fields = this?.els?.fields?.element?.value
    const email = this?.els?.email?.element?.value
    const consent = this?.els?.consent?.element?.checked

    if (!this.validEmail(email)) return

    if (consent !== true) return

    const data = {
      g: listId,
      email,
      $fields: fields,
      $consent: ['email'],
    }
    const urlData = new URLSearchParams(data)

    fetch(`https://manage.kmail-lists.com/ajax/subscriptions/subscribe`, {
      method: 'POST',
      body: urlData,
    }).then(res => {
      if (res.status === 200) {
        this.els.form.element.style.display = 'none'
        this.els.success.element.style.display = 'block'
      }
    })
  }

  validEmail (email) {
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    return emailRegex.test(email)
  }
}

if (!customElements.get('footer-newsletter')) {
  customElements.define('footer-newsletter', FooterNewsletter)
}
